import {mediaShareTextService} from '_app/services';
import {Enums} from '_app/utils';
import {
	SHARE_TEXTS_LOAD_FAILURE,
	SHARE_TEXTS_LOAD_REQUEST,
	SHARE_TEXTS_LOAD_SUCCESS,
	SHARE_EMAIL_DELETE_SUCCESS,
	SHARE_EMAIL_SAVE_SUCCESS,
	SHARE_SOCIAL_SAVE_SUCCESS
} from './shareTextsConstants';
import {addAlert} from '_app/shared/features/TransientNotifications/TransientNotificationsActions';
import {loadEmailTemplate} from '_app/shared/features/EmailTemplates/emailTemplatesActions';

const loadShareTextsRequest = mediaId => ({
	type: SHARE_TEXTS_LOAD_REQUEST,
	data: {
		mediaId
	}
});
const loadShareTextsFailure = mediaId => ({
	type: SHARE_TEXTS_LOAD_FAILURE,
	data: {
		mediaId
	}
});
const loadShareTextsSuccess = (mediaId, shareTexts) => ({
	type: SHARE_TEXTS_LOAD_SUCCESS,
	data: {
		mediaId,
		shareTexts
	}
});
const deleteShareEmailSuccess = mediaId => ({
	type: SHARE_EMAIL_DELETE_SUCCESS,
	data: {
		mediaId
	}
});
const saveShareEmailSuccess = (mediaId, email) => ({
	type: SHARE_EMAIL_SAVE_SUCCESS,
	data: {
		email,
		mediaId
	}
});
const saveShareSocialSuccess = (mediaId, social) => ({
	type: SHARE_SOCIAL_SAVE_SUCCESS,
	data: {
		social,
		mediaId
	}
});

export const loadShareTexts = mediaId => dispatch => {
	dispatch(loadShareTextsRequest(mediaId));

	return mediaShareTextService.fetch(mediaId)
		.then(data => {
			const social = [];
			const email = [];

			data.forEach(item => {
				if (item.type !== Enums.getType('shareTypes').EMAIL) {
					social.push(item);
					return;
				}
				email.push(item);
				if (item.templateID && item.templateVersion) {
					dispatch(loadEmailTemplate(item.templateID, item.templateVersion));
				}
			});
			dispatch(loadShareTextsSuccess(mediaId, {
				social,
				email
			}));
		})
		.catch(() => {
			dispatch(addAlert(`Failed to load share texts for media ${mediaId}`));
			dispatch(loadShareTextsFailure(mediaId));
		});
};

export const deleteShareEmail = shareEmail => dispatch => {
	let deferred;

	if (!shareEmail || shareEmail.length === 0) {
		deferred = $.Deferred().resolve().promise();
	} else {
		deferred = shareEmail
			.filter(item => item.id !== undefined && item.id !== null)
			.map(item => mediaShareTextService.remove(item.id));
	}
	return $.when.apply(this, deferred)
		.then(function() {
			dispatch(deleteShareEmailSuccess(shareEmail[0].mediaID));
		});
};

export const saveShareText = (mediaId, record) => {
	var result;

	if (record.id !== undefined && record.id !== null) {
		result = mediaShareTextService.update(record)
			.then(function() {
				return record;
			});
	} else {
		record.mediaID = mediaId;
		result = mediaShareTextService.create(record);
	}
	return result;
};

export const saveShareEmail = (mediaId, data) => (dispatch, getState) => {
	const shareEmail = getState().shareTexts[mediaId].email;
	const list = (shareEmail && shareEmail.length)
		? shareEmail
		: [{
			type: Enums.getType('shareTypes').EMAIL
		}];
	const deferred = list.map(function(e) {
		const record = $.extend({}, e);

		record.templateID = data ? data.MediaID : null;
		record.templateVersion = data ? data.Version : null;
		return saveShareText(mediaId, record);
	}, this);

	return $.when.apply(this, deferred)
		.then(function(shareEmail) {
			dispatch(saveShareEmailSuccess(mediaId, [shareEmail]));
		});
};

export const saveShareSocial = (mediaId, shareText) => dispatch => {
	var promises = shareText.map(function(item) {
		var record = $.extend({}, item);

		return saveShareText(mediaId, record);
	}, this);

	return $.when.apply(this, promises)
		.then(function(...shareSocial) {
			dispatch(saveShareSocialSuccess(mediaId, shareSocial));
		});
};